import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Chevron from '../assets/images/chevron.svg';
import { colors } from '../utils';

const ChevronIconBack = styled.img`
  height: 40px;
  width: 40px;
  transform: rotate(180deg);
`;

const BackLink = styled.a`
  display: flex;
  align-items: center;
  position: absolute;
  left: 20px;
  top: 90px;
  text-decoration: underline;

  &,
  &:active,
  &:visited {
    color: ${colors.g04};
  }

  &:hover {
    color: ${colors.g05};
    cursor: pointer;
  }
`;

export const BackHomeButton = ({ onClick }) => (
  <BackLink onClick={onClick}>
    <ChevronIconBack src={Chevron} />
    Go back to dashboard
  </BackLink>
);

BackHomeButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
